module.exports = __webpack_public_path__ + "static/img/2014.5fff3dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2014.png
// module id = adGs
// module chunks = 1